import React from "react";
import { Props } from "./types";
import styles from "./styles.scss";

function ProjectAdequacyInput({
  index,
  adequacyValue,
  strategicAxis,
  setStrategicAxis,
  placeholder,
}: Props) {
  return (
    <div className={styles.form}>
      <div className={styles.numberBox}>{adequacyValue}</div>
      <div className={styles.group}>
        <input
          type="text"
          className={styles.input}
          placeholder={placeholder}
          value={strategicAxis.adequacyPossibilities[index]}
          onChange={({ target }) => {
            setStrategicAxis({
              ...strategicAxis,
              adequacyPossibilities: {
                ...strategicAxis.adequacyPossibilities,
                [index]: target.value,
              },
            });
          }}
        />
      </div>
    </div>
  );
}

export { ProjectAdequacyInput };
